export default __webpack_public_path__ + "static/media/tablet-pos.c9c3d397.png";